export default __webpack_public_path__ + "static/IOVideo-519ff3205c377d05cf329f91cc296258.mp4";